import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as actions from '../../../../../actions/club-actions';
import * as searchActions from '../../../../../actions/search-actions';
import {
    isClubAdminOrOwner,
    isClubMember,
    isPersonalClub,
} from '../../../../../utils/clubs';
import MembersList from './MembersList';
import MembersFilters from './MembersFilters';
import MembersBulkActions from './MembersBulkActions';
import MembersTabTitleLayout from './MembersTabTitleLayout';
import Pagination from '../../../../Pagination';

import styles from '../../../../../pages/ClubProfiles/club.scss';

export class MembersTabContent extends Component {
    constructor(props) {
        super(props);
        this.membersListFilter = React.createRef();

        this.state = {
            filters: {
                utrType: 'verified',
            },
            sort: {
                field: 'firstName',
                order: 'asc',
            },
        };

        this.setFilters = this.setFilters.bind(this);
        this.setSorting = this.setSorting.bind(this);
        this.clearSorting = this.clearSorting.bind(this);
        this.onMemberSelected = this.onMemberSelected.bind(this);
        this.onHeaderAllSelectChange = this.onHeaderAllSelectChange.bind(this);
        this.removeMembers = this.removeMembers.bind(this);
        this.changeMembershipType = this.changeMembershipType.bind(this);
        this.paginationClick = this.paginationClick.bind(this);
        this.updateMembersTabState = this.updateMembersTabState.bind(this);
        this.selectAbsoluteAll = this.selectAbsoluteAll.bind(this);
        this.clearMemberSelection = this.clearMemberSelection.bind(this);
        this.membersFiltersRef = React.createRef();
    }

    componentDidMount() {
        this.props.updateSportTypes(this.props.auth?.user ? this.props?.auth?.feedPreferences : { showTennisContent: true, showPickleballContent: true });
        if (this.props.clubDetails?.id) {
            this.props.searchClubMembers(this.props.clubDetails.id);
        }
    }

    componentDidUpdate() {
        this.membersFiltersRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    onMemberSelected(i) {
        const { clubMembersFetchState, clubDetails, updateMemberSelection } = this.props;
        const selectedMembers = [...clubMembersFetchState.selectedMembers];
        selectedMembers[i] = !selectedMembers[i];
        const selectedMemberIds = clubDetails.clubMembers
            .filter((member, index) => selectedMembers[index])
            .map(member => member.memberId);
        updateMemberSelection({
            selectedMembers,
            selectedMemberIds,
            selectAllMembers: false,
        });
        console.log('selectedMemberIds', selectedMemberIds);
    }

    onHeaderAllSelectChange() {
        const { clubMembersFetchState, clubDetails, updateMemberSelection } = this.props;
        const selectedMembers = [...clubMembersFetchState.selectedMembers];
        const deselectAll = selectedMembers.length === clubDetails.clubMembers.length && selectedMembers.every(e => e);
        let selectedMemberIds = [];
        if (deselectAll) {
            this.clearMemberSelection();
        } else {
            // select all
            selectedMemberIds = clubDetails.clubMembers.map(member => member.memberId);
            updateMemberSelection({
                selectedMembers: clubDetails.clubMembers.map(() => true),
                selectedMemberIds,
                selectAllMembers: false,
            });
        }
        console.log('selectedMemberIds', selectedMemberIds);
    }

    setFilters(filters) {
        const { sort } = this.state;
        const finalFilters = filters.clearSort ? { ...filters } : { filters, sort };
        this.setState({
            filters,
        });
        this.props.searchClubMembers(this.props.clubDetails.id, finalFilters);
    }

    setSorting(sort) {
        const { filters } = this.state;
        this.setState({
            sort,
        });
        this.props.searchClubMembers(this.props.clubDetails.id, { filters, sort });
    }

    clearSorting() {
        this.setState({
            sort: {
                field: 'firstName',
                order: 'asc',
            },
        });
    }

    removeMembers() {
        const { selectAllMembers, selectedMemberIds } = this.props.clubMembersFetchState;
        const payload = selectAllMembers
            ? { all: true }
            : { memberIds: selectedMemberIds };
        this.props.removeClubMembers(this.props.clubDetails.id, payload);
    }

    changeMembershipType(type) {
        const { selectAllMembers, selectedMemberIds } = this.props.clubMembersFetchState;
        const payload = selectAllMembers
            ? { all: true, type }
            : { memberIds: selectedMemberIds, type };
        this.props.changeMembershipType(this.props.clubDetails.id, payload);
    }

    paginationClick(pageNumber) {
        console.log('paginationClick', pageNumber);
        const { sort, filters } = this.state;
        const skip = (pageNumber - 1) * 20;
        this.props.searchClubMembers(this.props.clubDetails.id, { filters, sort, skip });
        this.clearMemberSelection();
    }

    updateMembersTabState(membersTabState) {
        this.clearMemberSelection();
        this.props.updateMembersTabState(membersTabState);
    }

    selectAbsoluteAll() {
        const { selectedMembers, selectedMemberIds } = this.props.clubMembersFetchState;
        this.props.updateMemberSelection({
            selectedMembers,
            selectedMemberIds,
            selectAllMembers: true,
        });
    }

    clearMemberSelection() {
        this.props.updateMemberSelection();
    }

    render() {
        const {
            clubDetails,
            auth,
            clubType,
            membersTabState,
            clubMemberRoles,
            clubMembersFetchState,
            sendMessage,
            showInviteMembersModal,
        } = this.props;

        const {
            selectedMembers = [],
            selectedMemberIds = [],
            selectAllMembers,
        } = clubMembersFetchState;

        const {
            tierType,
            isEnterprise,
            isPro,
            clubMembersTotal,
            isPremium,
            isProCollege,
        } = clubDetails;

        const {
            adminViewType,
            memberViewType,
        } = membersTabState;

        const userLoggedIn = auth && auth.user;
        const userIsPowered = auth && auth.user && auth.user.isPowered;
        const isCollegeOrHighSchool = tierType && (tierType.isCollege || tierType.isHighSchool);
        const isCollege = tierType && tierType.isCollege;
        const isHighSchool = tierType && tierType.isHighSchool;
        const isAdminOrOwner = isClubAdminOrOwner(clubDetails);
        const isPersonal = isPersonalClub(clubDetails.tierType);
        const isMember = isClubMember(clubDetails);

        const showMembershipType = (adminViewType === 'members' && memberViewType === 'current') && (isEnterprise || isPro || isPremium || isProCollege);
        const showBillingType = adminViewType === 'members' && isClubAdminOrOwner(clubDetails) && (isEnterprise || isPremium || isProCollege);

        const showBulkActions = isAdminOrOwner && !!selectedMemberIds.length && adminViewType === 'members' && memberViewType === 'current';

        const showPagination = adminViewType === 'members' && memberViewType === 'current';
        const lastPage = Math.ceil(clubMembersTotal / 20);
        const currentPage = clubMembersFetchState && clubMembersFetchState.searchParams && clubMembersFetchState.searchParams.skip ? (clubMembersFetchState.searchParams.skip / 20) + 1 : 1;

        return (
            <div className="row">
                <div className="col-12">
                    <div className={`${styles.members}`} data-testid="club-profile.members">
                        <MembersTabTitleLayout
                            isAdminOrOwner={isAdminOrOwner}
                            isCollegeOrHighSchool={isCollegeOrHighSchool}
                            isCollege={isCollege}
                            isHighSchool={isHighSchool}
                            membersTabState={membersTabState}
                            clubDetails={clubDetails}
                            clubType={clubType}
                            // isPersonal={isPersonal}
                            updateMembersTabState={this.updateMembersTabState}
                            showMessagePopUp={this.props.showMessagePopUp}
                            exportMembers={this.props.exportMembers}
                            showInviteMembersModal={showInviteMembersModal}
                            user={userLoggedIn}
                        />
                        <div ref={this.membersFiltersRef}>
                            <MembersFilters
                                isAdminOrOwner={isAdminOrOwner}
                                isCollegeOrHighSchool={isCollegeOrHighSchool}
                                membersTabState={membersTabState}
                                clubDetails={clubDetails}
                                clubType={clubType}
                                user={userLoggedIn}
                                setFilters={this.setFilters}
                                filters={this.state.filters}
                                changeFilterInputs={this.props.changeFilterInputs}
                                // searchClubMembers={this.props.searchClubMembers}
                                removeMembers={this.removeMembers}
                                changeMembershipType={this.changeMembershipType}
                                sortState={this.state.sort}
                                setSorting={this.setSorting}
                                clearSorting={this.clearSorting}
                            />
                        </div>
                        {isAdminOrOwner && (
                            <MembersBulkActions
                                showBulkActions={showBulkActions}
                                removeMembers={this.removeMembers}
                                changeMembershipType={this.changeMembershipType}
                            />
                        )}
                        {clubMembersFetchState.loading
                            ? (
                                <div className={`mt48 text-center`}>
                                    <i className="fas fa-circle-notch fa-spin" /> Loading Members...
                                </div>
                            )
                            : (
                                <MembersList
                                    isAdminOrOwner={isAdminOrOwner}
                                    showMembershipType={showMembershipType}
                                    showBillingType={showBillingType}
                                    clubDetails={clubDetails}
                                    userIsPowered={userIsPowered}
                                    isMember={isMember}
                                    membersTabState={membersTabState}
                                    isCollegeOrHighSchool={isCollegeOrHighSchool}
                                    isCollege={isCollege}
                                    clubMemberRoles={clubMemberRoles}
                                    updateMembersTabState={this.updateMembersTabState}
                                    approveOrRejectRequest={this.props.approveOrRejectRequest}
                                    resendInvite={this.props.resendInvite}
                                    deleteInvite={this.props.deleteInvite}
                                    updateMemberRole={this.props.updateMemberRole}
                                    updateMemberType={this.props.updateMemberType}
                                    updateClubMemberPower={this.props.updateClubMemberPower}
                                    showError={this.props.showError}
                                    showOrganizerLimitPopup={this.props.showOrganizerLimitPopup}
                                    auth={auth}
                                    sendMessage={sendMessage}
                                    isPersonal={isPersonal}
                                    showUpgradeToPowerPopup={this.props.showUpgradeToPowerPopup}
                                    sortState={this.state.sort}
                                    setSorting={this.setSorting}
                                    filters={this.state.filters}
                                    selectedMembers={selectedMembers}
                                    onMemberSelected={this.onMemberSelected}
                                    onHeaderAllSelectChange={this.onHeaderAllSelectChange}
                                    selectAbsoluteAll={this.selectAbsoluteAll}
                                    clearSelection={this.clearMemberSelection}
                                    allMembersSelected={selectAllMembers}
                                    showCheckboxes={adminViewType === 'members' && memberViewType === 'current'}
                                    search={this.props.search}
                                />
                            )}
                        {showPagination && (
                            <Pagination
                                lastPage={lastPage}
                                currentPage={currentPage}
                                onClick={this.paginationClick}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ coreUI, search, auth }) {
    return { coreUI, search, auth };
}
function mapDispatchToProps(dispatch) {
    return {
        searchClubMembers: (clubId, filters) => {
            dispatch(actions.searchClubMembers(clubId, filters));
        },
        removeClubMembers: (clubId, payload) => {
            dispatch(actions.removeClubMembers(clubId, payload));
        },
        changeMembershipType: (clubId, payload) => {
            dispatch(actions.changeMembershipType(clubId, payload));
        },
        updateMemberSelection: (selectionArrays) => {
            dispatch(actions.updateMemberSelection(selectionArrays));
        },
        changeFilterInputs: (filters) => {
            dispatch(searchActions.changeFilterInputs(filters));
        },
        updateSportTypes: (feedPreferences) => dispatch(searchActions.updateSportTypes({ tennis: feedPreferences?.showTennisContent, pickleball: feedPreferences?.showPickleballContent })),
    };
}
MembersTabContent.propTypes = {
    updateSportTypes: PropTypes.func,
    auth: PropTypes.instanceOf(Object).isRequired,
    search: PropTypes.instanceOf(Object),
};

MembersTabContent.defaultProps = {
    updateSportTypes: () => { },
    search: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(MembersTabContent);
